import { ClientConsolidationFolder } from "@redotech/redo-views-common/folders";
import { ClientConsolidationView } from "@redotech/redo-views-common/views";
import * as z from "zod";
import { null as zNull } from "zod";

export const getConsolidationViewsAndFolders = {
  name: "getConsolidationViewsAndFolders" as const,
  input: zNull(),
  output: z.object({
    folders: z.array(ClientConsolidationFolder),
    views: z.array(ClientConsolidationView),
  }),
};
